import { render } from "./About.vue?vue&type=template&id=c14ecf04&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=c14ecf04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c14ecf04"

export default script